// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	// To make this Code work in all of your site pages,
	// Move these lines into the the 'Site Code' panel on the left

	$w("#headerTransitionPoint").onViewportLeave(() => {
		$w("#scrollingHeaderStrip").show();
		$w("#defaultHeaderStrip").hide();
	})
	$w("#headerTransitionPoint").onViewportEnter(() => {
		$w("#defaultHeaderStrip").show();
		$w("#scrollingHeaderStrip").hide();
	})
});